import fetch from "lib/fetch";
import type { MessageInterface } from "types/message";

type MessageResponse = { data: MessageInterface };
type MessageListResponse = { data: Array<MessageInterface> };

export const getMessageRequest = (id: string) =>
    fetch.get<MessageListResponse>(`messages/${id}`);

export const createMessageRequest = (data: HashMap<unknown>) =>
    fetch.post<MessageResponse>("messages", data);
